import { render } from "./RankingTableSummary012.vue?vue&type=template&id=ccebb05a&scoped=true"
import script from "./RankingTableSummary012.vue?vue&type=script&lang=js"
export * from "./RankingTableSummary012.vue?vue&type=script&lang=js"

import "./RankingTableSummary012.vue?vue&type=style&index=0&id=ccebb05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccebb05a"]])

export default __exports__